import { defineStore } from 'pinia'

export const useToastStore = defineStore({
  id: 'toastStore',
  state: () => ({
    toasts: [],
    lastId: 0,
  }),
  actions: {
    add({message, duration = 3, type}) {
      if (!message || !duration) return;
      const id = ++this.lastId;
      this.toasts.push({
        id: id,
        message: message,
        duration: duration,
        type: type,
      });
      setTimeout(() => {
        this.toasts = this.toasts.filter(toast => {
          return toast.id !== id;
        });
      }, duration);
    },
  },
  getters: {
    // toasts: (state) => state.toasts,
  }
})
